/**
 * 🎳 Le combo et le compteur du jour du chatteur, lus dans le feed des ventes.
 *
 * La fête de la vente (Kayla, 09-10-2026) montre « ta 3ᵉ vente du jour » et
 * monte d'un cran à chaque vente enchaînée, comme au bowling. Le feed temps
 * réel `recentForMe` porte les 20 dernières ventes de l'org : assez pour le
 * combo, PAS toujours assez pour la journée. Quand le feed ne remonte pas
 * jusqu'à minuit, le compte du jour serait faux — on ne l'affiche pas
 * (`null`) plutôt que d'afficher un chiffre inventé.
 *
 * Fonction pure, testée sans Convex (`__tests__/statsDuJour.test.ts`).
 */
import { estMaVente } from "./paymentVolume";

/** Deux ventes à moins de 30 min l'une de l'autre s'enchaînent. */
export const FENETRE_COMBO_MS = 30 * 60 * 1000;
/** Taille du feed `recentForMe` (convex/paymentNotifications.ts). */
export const TAILLE_FEED = 20;

export interface EvenementVente {
  createdAt: number;
  amountCents: number;
  currency: string;
  sellerWorkosUserId: string | null;
}

export interface StatsDuJour {
  combo: number;
  venteDuJour: number | null;
  totalDuJourCents: number | null;
}

/** `evenements` : du plus récent au plus ancien, comme le feed. */
export function statsDuJour(evenements: EvenementVente[], moi: string | null, maintenant: number): StatsDuJour {
  const miennes = evenements.filter((e) => estMaVente(e.sellerWorkosUserId, moi));
  let combo = 0;
  for (let i = 0; i < miennes.length; i++) {
    if (i > 0 && miennes[i - 1]!.createdAt - miennes[i]!.createdAt > FENETRE_COMBO_MS) break;
    combo++;
  }
  const minuit = new Date(maintenant);
  minuit.setHours(0, 0, 0, 0);
  const plusAncien = evenements[evenements.length - 1];
  const complet = evenements.length < TAILLE_FEED || (plusAncien !== undefined && plusAncien.createdAt < minuit.getTime());
  const duJour = miennes.filter((e) => e.createdAt >= minuit.getTime());
  const uneDevise = new Set(duJour.map((e) => e.currency)).size <= 1;
  return {
    combo: Math.max(1, combo),
    venteDuJour: complet ? duJour.length : null,
    totalDuJourCents: complet && uneDevise ? duJour.reduce((s, e) => s + e.amountCents, 0) : null,
  };
}
